// Keys used against localStorage. A misspelled key does not fail: it returns
// null and the caller silently falls back, so the value belongs here rather
// than inline at each call site.
export const STORAGE_KEYS = {
    SIZE_PER_PAGE: 'sizePerPage',
    SESSION_USER: 'sessionUser',
    NEW_EMAIL: 'newEmail',
    RECOVER_TOKEN: 'recoverToken',
};
